let facebookShare = () => {
  window.open(
    ('https://www.facebook.com/sharer/sharer.php?u=' + window.location),
    'pop',
    'width=800, height=400, top=100, left=' + ((window.outerWidth / 2) - 400) + ', scrollbars=no'
  );

  return false;
};

let addToGoogleCalendar = (title, start, end, details, location) => {
  let params = {
    action: 'TEMPLATE'
  };

  if (title) params['text'] = title;
  if (start && end) {
    params['dates'] =
      (new Date(start)).toISOString().replace(/-|:|\.\d\d\d/g, '') + '/' + (new Date(end)).toISOString().replace(/-|:|\.\d\d\d/g, '');
  }
  if (details) params['details'] = details;
  if (location) params['location'] = location;

  window.open('http://www.google.com/calendar/event?' + objectToParams(params),
              'pop', 'width=900, height=400, top=100, left=' + ((window.outerWidth / 2) - 450) + ', scrollbars=no');
};

// Util
let objectToParams = (obj) => {
  var p = [];
  for (var key in obj) {
    p.push(key + '=' + encodeURIComponent(obj[key]));
  }
  return p.join('&');
};

let validateEmail = (email) => {
  // eslint-disable-next-line
  return /^([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x22([^\x0d\x22\x5c\x80-\xff]|\x5c[\x00-\x7f])*\x22)(\x2e([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x22([^\x0d\x22\x5c\x80-\xff]|\x5c[\x00-\x7f])*\x22))*\x40([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x5b([^\x0d\x5b-\x5d\x80-\xff]|\x5c[\x00-\x7f])*\x5d)(\x2e([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x5b([^\x0d\x5b-\x5d\x80-\xff]|\x5c[\x00-\x7f])*\x5d))*$/.test(email);
};

let getParameterByName = (name, url) => {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, '\\$&');
  var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
  var results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
};

let createCookie = (name, value, days) => {
  var expires;
  if (days) {
    let date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = '; expires=' + date.toGMTString();
  } else {
    expires = '';
  }

  document.cookie = name + '=' + value + expires + '; path=/';
};

let readCookie = (name) => {
  var nameEQ = name + '=';
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
};

let eraseCookie = (name) => {
  createCookie(name, '', -1);
};

export { facebookShare, addToGoogleCalendar, validateEmail, getParameterByName, createCookie, readCookie, eraseCookie };



// WEBPACK FOOTER //
// ./src/components/Utils/index.js